/* document-load.ts|js file - the code is the same for both the languages */
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
import {
  resourceFromAttributes,
  defaultResource,
} from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

import { environment } from './environments/environment';

if (environment.name !== 'development') {
  const DT_API_URL = environment.dynatraceApiUrl;
  const DT_API_TOKEN = environment.dynatraceApiToken;

  const resource = defaultResource().merge(
    resourceFromAttributes({
      [ATTR_SERVICE_NAME]: 'MdmXref.UI',
      'deployment.environment': environment.name,
    }),
  );

  const traceExporter = new OTLPTraceExporter({
    url: `${DT_API_URL}/v1/traces`,
    headers: {
      Authorization: `Api-Token ${DT_API_TOKEN}`,
    },
  });

  const traceBatchSpanProcessor = new BatchSpanProcessor(traceExporter, {
    maxQueueSize: 100,
    maxExportBatchSize: 50,
    scheduledDelayMillis: 5000,
    exportTimeoutMillis: 30000,
  });

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [traceBatchSpanProcessor],
  });

  provider.register({
    contextManager: new ZoneContextManager(),
  });

  // Registering instrumentations
  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {},
        '@opentelemetry/instrumentation-user-interaction': {},
        '@opentelemetry/instrumentation-fetch': {},
        '@opentelemetry/instrumentation-xml-http-request': {},
      }),
    ],
  });
}
